import React, { useState } from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components";

import Dropdown from "components/atoms/Dropdown";
import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";
import Button from "components/atoms/button/Button";
import { BUTTON_STYLES } from "components/atoms/button/presets";
import Text from "components/atoms/text/Text";

const Container = styled.div`
    width: 100%;
`;

const ResearchItemWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: auto;
    max-width: 180px;
    min-height: 20px;
`;

const ResearchItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${(props) => props.$margin || "2px"};
    padding: 2px 4px;
    max-width: 180px;
    height: 20px;
    outline: none;
    background-color: var(--color-Research);
    border: transparent;
    border-radius: 2px;
    cursor: pointer;
    transition: all 120ms ease-in;

    &:hover {
        background-color: var(--color-ResearchActive);
    }
`;

const MoreResearch = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 0;
    padding: 2px 4px;
    max-width: 180px;
    height: 20px;
    outline: none;
    background-color: var(--color-ResearchActive);
    border: transparent;
    border-radius: 2px;
    cursor: pointer;
`;

const BlankBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
    background-color: var(--color-BaseBlue);
    border-radius: 4px;
`;

const BlankText = styled(Text)`
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

const MoreBox = styled.div`
    width: 240px;
    max-width: 240px;
    min-height: 80px;
    background-color: var(--color-White);
    border: solid 1px var(--color-Outline);
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1;
`;

const MoreBoxHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    width: 100%;
    height: 32px;
    border-bottom: solid 1px var(--color-Outline);
`;

const MoreContentWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 8px 8px 8px 8px;
    max-width: 240px;
    max-height: 160px;
    overflow-x: hidden;
    overflow-y: auto;
`;

const ResearchListTitle = styled(Text).attrs({
    variant: "body-md-500",
    color: "var(--color-SubBlack)",
})``;

const ResearchListText = styled(Text).attrs({
    variant: "body-sm-400",
    color: "var(--color-SubBlack)",
    ellipsis: true,
})``;

function ReferenceResearchList(props) {
    const { space_uuid } = useParams();

    const [showResearchBox, setShowResearchBox] = useState(false);

    return (
        <Container>
            {props.reference.researches?.length > 0 ? (
                <ResearchItemWrap>
                    <Tooltip message={"연구노트로 이동"}>
                        <ResearchItem
                            $margin={"0 4px 0 0"}
                            style={
                                props.reference.researches.length > 1 ? { maxWidth: "140px" } : { maxWidth: "180px" }
                            }
                            onClick={(e) => {
                                e.stopPropagation();
                                window.open(
                                    `/${space_uuid}/research/${props.reference.researches[0].research_no}`,
                                    "_blank",
                                    "noopener noreferrer",
                                );
                            }}
                        >
                            <ResearchListText>{props.reference.researches[0].display_name}</ResearchListText>
                        </ResearchItem>
                    </Tooltip>
                    {props.reference.researches.length > 1 && (
                        <Dropdown
                            open={showResearchBox}
                            onOpenChange={setShowResearchBox}
                            placement="bottom-end"
                            offset={8}
                            anchor={
                                <MoreResearch
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setShowResearchBox((prev) => !prev);
                                    }}
                                >
                                    <ResearchListText>+{props.reference.researches.length - 1}</ResearchListText>
                                </MoreResearch>
                            }
                        >
                            <MoreBox>
                                <MoreBoxHeader>
                                    <ResearchListTitle>연구노트</ResearchListTitle>
                                    <Button
                                        {...BUTTON_STYLES.iconGhost}
                                        buttonSize={"20px"}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowResearchBox(!showResearchBox);
                                        }}
                                    >
                                        <Icon name={"x"} size={"8"} color={"var(--color-SubBlack)"} />
                                    </Button>
                                </MoreBoxHeader>
                                <MoreContentWrap>
                                    {props.reference.researches.map((research, index) => (
                                        <Tooltip message={"연구노트로 이동"} key={research + index}>
                                            <ResearchItem
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    window.open(
                                                        `/${space_uuid}/research/${research.research_no}`,
                                                        "_blank",
                                                        "noopener noreferrer",
                                                    );
                                                }}
                                            >
                                                <ResearchListText>{research.display_name}</ResearchListText>
                                            </ResearchItem>
                                        </Tooltip>
                                    ))}
                                </MoreContentWrap>
                            </MoreBox>
                        </Dropdown>
                    )}
                </ResearchItemWrap>
            ) : (
                <BlankBox>
                    <BlankText>연결된 연구노트가 없습니다.</BlankText>
                </BlankBox>
            )}
        </Container>
    );
}

export default ReferenceResearchList;
